// extracted by mini-css-extract-plugin
module.exports = {"features__header":"styles_features__header__6pgsD","features__benefits":"styles_features__benefits__bhkYB"};